import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';
import { ECadastralFieldsNames } from '../../types/reducers/rosreestrData';

export const SET_REQUIRED_ERROR = 'CADASTRAL_FIELDS :: SET_REQUIRED_ERROR';

interface IFieldError {
  key: ECadastralFieldsNames;
  value: boolean;
}

export type TSetRequiredErrorAction = IReduxAction<typeof SET_REQUIRED_ERROR, IFieldError>;

export const setRequiredError = actionGenerator<typeof SET_REQUIRED_ERROR, IFieldError>(SET_REQUIRED_ERROR);
